import { SelectableEntity } from '@infodata-group/inf-commons';

export class SelectableEntityBuilder {
  private _entity: SelectableEntity;

  constructor(id: string, label: string, display?: 'id' | 'label' | 'full') {
    this._entity = new SelectableEntity(id, label, display);
  }

  public setIcon(icon: string): SelectableEntityBuilder {
    this._entity.icon = icon;
    return this;
  }

  public setIconColor(iconColor: string): SelectableEntityBuilder {
    this._entity.iconColor = iconColor;
    return this;
  }

  public build(): SelectableEntity {
    return this._entity;
  }
}
